import { Component } from '@angular/core';
import { linkLenguages } from 'src/app/shared/utils/lenguages';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  language = localStorage.getItem("language");

  lengragueList = linkLenguages

  setLanguage(language: string) {
        
    this.language = language;
    localStorage.setItem("language", language);
    window.location.reload();
}

}
